
const getVarsList = function(input = ''){

  const normalized = String(input || '').replace(/\$\{([a-zA-Z_0-9.\s]+)\}/g, '$($1)');
  const _regex = /(\$\([a-zA-Z_0-9.\s]+\))/g;
  return (normalized.match(_regex) || []).map(variavel => ({
    value: variavel,
    newValue: `<var attr="${variavel.substr(2, variavel.length - 3)}" />`
  }));

};

export default getVarsList;
